import * as React from 'react';
import { ArticleHeading2 } from '@cian/ui-kit/typography';
import { Responsive } from '@cian/ui-kit/responsive';
import { Button } from '@cian/ui-kit/button';
import { IconActionChevronUp16, IconActionChevronDown16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx as cx } from 'clsx';

import * as styles from './Document.css';
import { ILegalDocument } from '../../types/document';
import { ILegalDocumentLink } from '../../types/link';
import { Links } from '../Links';
import { useVisibleOnScroll } from '../../utils/hooks/useVisibleOnScroll';
import { useHiddenBellowOffset } from '../../utils/hooks/useHiddenBellowOffset';

interface IDocumentProps {
  document: ILegalDocument;
  links: ILegalDocumentLink[];
}

export const Document: React.FC<IDocumentProps> = ({ document, links }) => {
  const [open, setOpen] = React.useState(false);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const isVisibleOnScrollToTop = useVisibleOnScroll(30);
  const isVisibleUnderOffset = useHiddenBellowOffset(100, false);

  return (
    <article className={styles['page']}>
      <Responsive desktop>
        <aside className={styles['aside']}>
          <Links links={links} activeLink={document.link} />
        </aside>
      </Responsive>
      <main className={styles['main']}>
        <div className={styles['title']}>
          <ArticleHeading2 as="h1">{document.title}</ArticleHeading2>

          <Responsive tablet phone>
            <div className={styles['arrow']}>
              <Button
                size="XS"
                theme="fill_white_primary"
                beforeIcon={
                  !open ? (
                    <IconActionChevronDown16 color="icon-main-default" />
                  ) : (
                    <IconActionChevronUp16 color="icon-main-default" />
                  )
                }
                onClick={() => setOpen(!open)}
              />
            </div>
          </Responsive>
        </div>
        {open && (
          <Responsive tablet phone>
            <div className={styles['links']}>
              <Links links={links} activeLink={document.link} hideActive />
            </div>
          </Responsive>
        )}
        {/* eslint-disable-next-line react/no-danger */}
        <div className={styles['body']} dangerouslySetInnerHTML={{ __html: document.htmlText }} />
        <div className={styles['sticky-cont']}>
          <div
            className={cx(styles['sticky-inner'], {
              [styles['sticky-inner-visible']]: isVisibleOnScrollToTop && !isVisibleUnderOffset,
            })}
          >
            <Button
              size="XS"
              theme="fill_primary"
              beforeIcon={<IconActionChevronUp16 color="icon-on-bright-default" />}
              onClick={scrollToTop}
            >
              Наверх
            </Button>
          </div>
        </div>
      </main>
    </article>
  );
};
